import { styled } from '@mui/material';
import { Box } from 'shared/mui/Box';

export const ApiClientsShowTopPanelWrapper = styled(Box)(({ theme }) => ({
  height: '54px',
  width: '100%',
  display: 'flex',
  backgroundColor: theme.palette.background.default,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '4px',
}));

export const ApiClientsShowTopPanelItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0 16px',
  '&:not(:last-child)': {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
}));
